import { render } from "./PaymentMethod.vue?vue&type=template&id=63815412&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=63815412&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63815412"]])

export default __exports__